<template>
	<action-card
		v-if="plans.length"
		:title="$t('payment-plans.upcoming-payments')"
		icon="calendar-range"
		:count="plans.length"
		@open="openPlans"
	>
		<button v-for="plan in visiblePlans" :key="plan.id" type="button" class="portal-action-row" @click="openPlan(plan)">
			<span class="action-row-copy">
				<strong>{{ plan.name || $t('payment-plans.untitled') }}</strong>
				<small v-if="next(plan)">
					{{ $t('payment-plans.remaining') }}: {{ money(plan.remaining, plan.currency) }} ·
					{{ next(plan).label }} · {{ trigger(next(plan)) }}
				</small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';
	import { nextStep, triggerLabel } from '@/modules/invoices/paymentPlanDisplay';

	export default {
		name: 'PaymentPlans',
		components: { ActionCard },
		props: {
			plans: { type: Array, default: () => [] },
		},
		computed: {
			visiblePlans() {
				return this.plans.slice(0, 5);
			},
		},
		methods: {
			next: nextStep,
			money(amount, currency) {
				return this.$formatters.dollars(amount || 0, true, true, currency);
			},
			trigger(step) {
				if (step.state === 'PREPARING') return this.$t('payment-plans.preparing-invoice');
				return triggerLabel(this.$i18n, step);
			},
			openPlans() {
				this.$router.push('/invoices?v=plans');
			},
			openPlan(plan) {
				this.$router.push({ path: '/invoices', query: { v: 'plans', plan: plan.id } });
			},
		},
	};
</script>
